<template>
  <el-dialog
    class="add-leave-dialog"
    title="外出请假审批"
    :visible.sync="show"
    :close-on-click-modal="false"
    width="920px"
    :before-close="cancel">
    <template v-if="init">
      <div id="leaveTemp">
        <div class="table-form-header" style=" text-align: center; padding-bottom: 40px; font-size: 20px;">
          <h3>广东南方职业学院学生请假审批表</h3>
        </div>
        <div class="table-form-content">
          <el-form ref="form" :model="formData" :rules="comptRules" style="padding-right: 0;">
            <table class="table" border="1"
                   style=" width: 100%; border-collapse: collapse; table-layout: fixed;font-size:15px;">
              <colgroup>
                <col style="width:130px;">
                <col>
                <col style="width:100px;">
                <col>
                <col style="width:90px;">
                <col>
              </colgroup>
              <tr>
                <td class="td-height__40 font-right">所在二级学院</td>
                <td class="td-height__40">
                  <span>{{ formData.userInfo.collegeName }}</span>
                </td>
                <td class="td-height__40 font-right">请假人姓名</td>
                <td class="td-height__40">
                  {{ formData.stuName }}
                </td>
                <td class="td-height__40 font-right">班级</td>
                <td class="td-height__40">
                  {{ formData.userInfo.className }}
                </td>
              </tr>
              <tr>
                <td class="td-height__40 font-right">请假人联系方式</td>
                <td colspan="2">
                  {{ formData.userInfo.fixedPhone }}
                </td>
                <td style="text-align: right">父母联系方式</td>
                <td colspan="2">
                  {{ formData.userInfo.fatherMotherPhone || formData.userInfo.fatherPhone || formData.userInfo.motherPhone
                  }}
                </td>
              </tr>
              <tr>
                <td style="text-align: right">请假时间</td>
                <td colspan="5">
                  {{ formData.beginTime | formatDate('YYYY年MM月DD日HH时mm分')
                  }} — {{ formData.endTime | formatDate('YYYY年MM月DD日HH时mm分')
                  }}（{{ calcuTimeLong(formData.timeLong)
                  }}）
                </td>
              </tr>
              <tr style="height: 50px;">
                <td style="text-align: right">请假原因及前往地点</td>
                <td colspan="5">
                  <div v-if="formData.address">前往：{{ formData.address }}</div>
                  办何事：{{ formData.leaveReason }}
                </td>
              </tr>
              <tr>
                <td colspan="6" style="padding: 0;height: 100%;">
                  <leaveTempPrint
                    :filter-type-map-list="filterTypeMapList"
                    v-show="!comptuPermitStatus||isPrint" :leave-data="formData" />
                  <leaveTempForm
                    :filter-type-map-list="filterTypeMapList"
                    v-show="comptuPermitStatus&&!isPrint" ref="formRef" :form-data="formData" />
                </td>
              </tr>
            </table>
            <p>
              注：1．本表上联由学生个人保存，下联由辅导员妥善保管。2．请假3个工作日内（含）由辅导员审批；4-5个工作日内由学院学生工作办公室审批；6-10个工作日由学院分管学生工作领导审批；11-13个工作日由学生处审批；14个工作日以上（含14天）由分管校领导审批。3．请病假者须提供医院病历证明或医生证明，请事假须说明具体事假理由。4．假满后必须及时与辅导员联系、销假<b>（病历复印件钉在本表后面）</b>。
            </p>
          </el-form>
        </div>
      </div>
    </template>
    <template #footer>
      <cancel-popover ref="cancelRef" :disabled.sync="loadData.loading" :update-flag="updateFlag" />
      <el-button v-if="comptuPermitStatus" type="primary" @click="save('请假申请',addLeave)">确 定
      </el-button>
      <el-button type="primary" plain icon="el-icon-printer" @click="printSignForm">打 印</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { addLeave, getLeaveById } from '@/api/leave'
import { getStudentByUserId } from '@/api/student'
import leaveTempPrint from './leaveTempPrint.vue'
import leaveTempForm from './leaveTempForm.vue'
import dialog from '@/vue/mixins/dialog'
import { hasPermission } from '@/utils/common-js'
import { Decimal } from 'decimal.js'
import store from '@/store'

export default {
  mixins: [dialog],
  components: {
    leaveTempForm,
    leaveTempPrint
  },
  props: {
    currentLeaveRole: {
      type: Object,
      default: () => store.state.login.currentLeaveRole
    },
    filterTypeMapList: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      isPrint: false,
      formData: {},
      init: false,
      TEMPLATE_HTML_URL: `${process.env.BASE_URL}print/leaveTemp.html`
    }
  },
  computed: {
    comptRules() {
      const _rules = {}
      if (this.currentLeaveRole?.statusKey) {
        _rules[this.currentLeaveRole.statusKey] = {
          required: true,
          message: '请选择审批意见',
          trigger: 'blur'
        }
        // 0==不通过,必填审批意见
        if (this.formData[this.currentLeaveRole.statusKey] === 0) {
          _rules[this.currentLeaveRole?.editKey + 'Opinion'] = {
            required: true,
            message: '请输入审批意见。',
            trigger: 'blur'
          }
        }
        this.$refs.form && this.$refs.form.clearValidate()
      }
      return _rules
    },
    comptuPermitStatus() {
      let _flag = false
      if (this.currentLeaveRole && hasPermission(this.currentLeaveRole.permitKey)) {
        _flag = !this.formData[this.currentLeaveRole.key]
      }
      return _flag
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.id) {
        this.preTitle = '审批'
        this.getLeaveById()
      }
    })
  },
  methods: {
    addLeave, // 保存api
    // 根据id请假信息
    getLeaveById() {
      getLeaveById(this.id).then((res) => {
        this.formData = res.data
        this.formData.timeLong = +(res.data.timeLong)
        if (this.currentLeaveRole?.filterType) {
          this.formData.filterType = this.currentLeaveRole.filterType
        } else {
          // 超管角色，用于预览打印
          this.formData.filterType = 0
        }
        if (res.data.userId) {
          this.getStudentByUserId(res.data.userId)
        }
      })
    },
    // 根据id获取学生信息
    getStudentByUserId(userId) {
      getStudentByUserId(userId).then(res => {
        this.formData.userInfo = res.data
        this.init = true
        this.setInitData()
      })
    },
    /* 打印报名表单 */
    printSignForm() {
      this.isPrint = true
      if (this.isPrint) {
        const report = document.querySelector('#leaveTemp')
        const iframe = document.createElement('iframe')
        const iframeStyle =
          'border:0;position:absolute;width:0px;height:0px;right:0px;top:0px;table{border-collapse: collapse;}'
        iframe.style.cssText = iframeStyle
        const id = new Date().getTime()
        iframe.id = id
        iframe.src = this.TEMPLATE_HTML_URL
        document.body.appendChild(iframe)
        iframe.onload = () => {
          iframe.contentDocument.querySelector('#leaveForm').innerHTML = this.nodeToString(report)
          setTimeout(() => {
            iframe.contentWindow.print()
          }, 1000)
          setTimeout(() => {
            iframe.remove()
            this.close()
          }, 1000)
        }
      }
    },
    nodeToString(node) {
      let tmpNode = document.createElement('div')
      tmpNode.appendChild(node.cloneNode(true))
      const str = tmpNode.innerHTML
      tmpNode = node = null
      return str
    },
    // 不足24小时的按小时显示，否则按天显示
    calcuTimeLong(day) {
      if (!day) return
      if (day && Number(day) < 1) {
        return new Decimal(Number(day)).mul(24) + '小时'
      } else {
        const _times = day.toString().split('.')
        if (Number(_times[1])) {
          return `${_times[0]}天${new Decimal(Number('0.' + _times[1])).mul(24)}小时`
        } else {
          return `${day}天`
        }
      }
    }
  }
}
</script>
<style lang="scss">
.add-leave-dialog {
  .el-dialog {
    margin-top: 5vh !important;

    #leaveTemp {
      .signature {
        margin-left: -110px;
        margin-right: 70px;
      }

      .signature-date {
        font-size: 14px;
      }

      .table-form-header {
        text-align: center;
        padding-bottom: 40px;
        font-size: 20px;
      }

      .table-form-content {
        .table {
          width: 100%;
          border-collapse: collapse;
          table-layout: fixed;

          tr {
            .textCenter {
              text-align: center;
            }

            .font-right {
              text-align: right;
            }

            .flex-between {
              display: flex;
              justify-content: space-between;
            }

            td {
              padding: 0 10px;
              font-size: 15px;
              line-height: 40px;
              box-sizing: border-box;
              height: 100%;

              &.td-height__40 {
                height: 40px;

              }
            }
          }
        }
      }
    }

    .leave-temp.table {
      table-layout: fixed;

      td {
        border-right: 1px solid #000;
        border-bottom: 1px solid #000;
      }

      tr {
        td:last-child {
          border-right: 0;
        }

        &:last-child {
          td {
            border-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
